import { EmptyState } from '@ailab/ui';

export function ComingSoonPage({ title }: { title: string }) {
  return (
    <>
      <h1>{title}</h1>
      <EmptyState title="Estamos preparando esta sección de AILAB." />
    </>
  );
}
